import React from 'react';
import SpaceRoleRequiredUsersForm from './SpaceRoleRequiredUsersForm';

function SpacesSettingManageForm(props) {
  return (
    <SpaceRoleRequiredUsersForm
      {...props}
      role="admin"
      description="管理员有权限阅览和修改所有信息"
    />
  );
}

export default SpacesSettingManageForm;
